module.exports = __webpack_public_path__ + "static/5-66d65f694cd9e63dde150a26e3099f28.jpg";